const baseURL = process.env.REACT_APP_BASE_URL;

export const getImg = (id) => {
  if (!id) return null;
  return `${baseURL}/api/Storage/GetImageById?id=${id}`;
};

export const getPdfUrl = (docId) => {
  if (!docId) return null;
  return `${baseURL}/api/Storage/GetPDFById?Id=${docId}`;
};